/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

import React, { ReactElement, ReactNode } from "react"
import { Link } from "react-router-dom"
import BookingLayout from "../../booking/components/booking-layout"
import { bookingColors } from "../../booking/booking-theme"
import { Paths } from "../../../const"
import heartReportCopy from "../heartReportCopy"

/**
 * The booking wizard's page chrome with this page's own header label, plus the white
 * card every screen of the flow sits in. Kept as one component so the four screens
 * share a single frame.
 */
const HeartReportLayout = ({ children }: { children: ReactNode }): ReactElement => (
  <BookingLayout appName={heartReportCopy.appName}>{children}</BookingLayout>
)

const HeartReportCard = ({ title, children }: { title: string; children: ReactNode }): ReactElement => (
  <HeartReportLayout>
    <div className="max-w-md mx-auto mt-16 bg-white rounded-lg shadow-sm px-8 py-10">
      <h1 className="text-2xl font-bold text-center" style={{ color: bookingColors.primary }}>
        {title}
      </h1>
      {children}
    </div>
  </HeartReportLayout>
)

/** In-app link to the portal's support page. */
const SupportLink = ({
  children,
  className = "underline",
}: {
  children: ReactNode
  className?: string
}): ReactElement => (
  <Link to={Paths.support} className={className}>
    {children}
  </Link>
)

export { HeartReportCard, SupportLink }
export default HeartReportLayout
